module.exports = __webpack_public_path__ + "static/media/gestor-qr.865607ad.png";